import React, { useCallback } from 'react';

import { useStore } from 'core/store/';
import { OfferPageTabs } from 'core/store/offer-store';
import { useToast } from 'core/components/toast';
import { Discount } from '../discount';

const DrivingCourse = ({ ...discount }) => {
  const { offer: store } = useStore();
  const toast = useToast();

  const onAddClick = useCallback(() => {
    if (store.currentTab !== OfferPageTabs.PEOPLE) {
      store.setCurrentTab(OfferPageTabs.PEOPLE);
    }
    store.setScrollTo('drivers');
    store.setUiHelpers({ eligibleDrivingCourseDriversCardsOpen: true });
    toast.notify({
      type: 'success',
      message:
        'Identify eligible drivers who have taken a qualified driving course to apply the driving course discount.'
    });
  }, [store, toast]);

  return <Discount {...discount} onAdd={onAddClick} />;
};

export default DrivingCourse;
